import { useAtomValue } from "jotai";
import React, { FC, useContext, useEffect, useRef } from "react";
import { helpContextAtom } from "../../../../atoms";
import { Grid, IconButton } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import { smetaModals, SmetaModalsIdContext } from "../../Tools/modalManager";

const DialogHelpContext: FC = () => {
  const helpContextUrl = useAtomValue(helpContextAtom);
  const iframeRef = useRef<HTMLIFrameElement>(null!);
  const smetaModalId = useContext(SmetaModalsIdContext);
  useEffect(() => {
    if (!helpContextUrl) smetaModals.close(smetaModalId);
  }, []);

  return (
    <Grid
      container
      direction="column"
      sx={{
        height: "100%",
        alignItems: "streach",
      }}
    >
      <Grid>
        <IconButton
          onClick={() => {
            iframeRef.current.src = helpContextUrl;
          }}
        >
          <HomeIcon fontSize="small" />
        </IconButton>
      </Grid>
      <Grid sx={{ flex: "1 1 auto" }}>
        <iframe ref={iframeRef} src={helpContextUrl} style={{ height: "97%", width: "100%" }} />
      </Grid>
    </Grid>
  );
};

export default DialogHelpContext;
